// @ts-nocheck

export type TicketGetWithOcAssignee = typeof TicketGetWithOcAssignee[keyof typeof TicketGetWithOcAssignee];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithOcAssignee = {
  true: 'true',
  false: 'false',
} as const;
